<app-side-menu (toggle)="toggleCollapse($event)"></app-side-menu>

<head>
  <link rel="stylesheet" href="vendor-management.component.css" importance="1">
  <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/materialize/1.0.0/css/materialize.min.css">
  <link href="https://fonts.googleapis.com/icon?family=Material+Icons" rel="stylesheet">

</head>

  <body class="green lighten-5">
    <script src="https://cdnjs.cloudflare.com/ajax/libs/materialize/1.0.0/js/materialize.min.js"></script>
    <div class="navbar" [class.admin-expanded]="isNavbarExpanded">
      <app-navbar></app-navbar>
    </div>
    
    <div class="main-panel" [class.admin-expanded]="isNavbarExpanded">
    <br>
    <br>
    <br>

    <div class="card" style="border-radius: 10px;">
      <div class="header-row">
        <div>
          <h3 class="page-title"><b>{{ title }}</b></h3>
          <h6 class="page-subtitle">Manage all vendor profiles.</h6>
        </div>

        <div class="header-actions">
          <button type="button" class="btn-action btn-primary" (click)="downloadAll()" [disabled]="loadingSubmissions || exporting || exportTotalCount === 0">
            <i class="material-icons left">file_download</i>
            Download All (Excel)
          </button>
        </div>
      </div>
      
      <div class="row-container">
        <div class="approved-card">
          <div class="card-grid">
            <div class="card-left">
              <h6 class="status-text">Approved</h6>
              <h4 class="status-count">{{ activeSystemCount }}</h4>
            </div>
            <div class="card-right">
              <i class="medium material-icons status-icon">trending_up</i>
            </div>
          </div>
        </div>
    
        <div class="declined-card">
          <div class="card-grid">
            <div class="card-left">
              <h6 class="status-text">Declined</h6>
              <h4 class="status-count">{{ inactiveSystemCount }}</h4>
            </div>
            <div class="card-right">
              <i class="medium material-icons status-icon">trending_down</i>
            </div>
          </div>
        </div>
    
        <div class="under-review-card">
          <div class="card-grid">
            <div class="card-left">
              <h6 class="status-text">Under Review</h6>
              <h4 class="status-count">{{ underReviewCount }}</h4>
            </div>
            <div class="card-right">
              <i class="medium material-icons status-icon">schedule</i>
            </div>
          </div>
        </div>

        <div class="vendor-action-card">
          <div class="card-grid">
            <div class="card-left">
              <h6 class="status-text">Action Required</h6>
              <h4 class="status-count">{{ vendorActionRequiredCount }}</h4>
            </div>
            <div class="card-right">
              <i class="medium material-icons status-icon">notification_important</i>
            </div>
          </div>
        </div>
      </div>
    
      <div class="filter-row">
        <p *ngIf="exportError" class="export-error" role="alert">{{ exportError }}</p>

        <div class="filter-buttons">
          <!-- Trigger Button -->
          <a class="dropdown-trigger btn-style" href="#" data-target="statusDropdown">
            {{ selectedStatus || 'All Accounts' }}
            <i class="tiny icon-inline material-icons right">keyboard_arrow_down</i>
          </a>

          <!-- Dropdown Content -->
          <ul id="statusDropdown" class="dropdown-content">
            <li><a (click)="filterByStatus('')">All Accounts</a></li>
            <li><a (click)="filterByStatus('Active')">Approved</a></li>
            <li><a (click)="filterByStatus('Flagged')">Flagged</a></li>
            <li><a (click)="filterByStatus('Declined')">Declined</a></li>
            <li><a (click)="filterByStatus('Pending')">Under Review</a></li>
          </ul>
        </div>

        <div class="search-container">
          <i class="icon-inline material-icons">search</i>
          <input type="text" [(ngModel)]="searchText" (input)="filterTable()" placeholder="Search..." class="browser-default">
        </div>
      </div>
    
      <!-- Add scrollable wrapper for table -->
      <div class="table-wrapper">
        <table class="highlight vendor-table">
          <thead>
            <tr class="table-header">
              <th (click)="sortTable('company')" class="sortable">
                Company
                <i class="material-icons tiny sort-icon" 
                   [ngClass]="{'active': sortColumn === 'company', 'inactive': sortColumn !== 'company'}">
                  {{ sortColumn === 'company' && sortDirection === 'desc' ? 'arrow_drop_down' : 'arrow_drop_up' }}
                </i>
              </th>
              <th (click)="sortTable('strName')" class="sortable">
                Representative
                <i class="material-icons tiny sort-icon" 
                   [ngClass]="{'active': sortColumn === 'strName', 'inactive': sortColumn !== 'strName'}">
                  {{ sortColumn === 'strName' && sortDirection === 'desc' ? 'arrow_drop_down' : 'arrow_drop_up' }}
                </i>
              </th>
              <th (click)="sortTable('strEmail')" class="sortable">
                Email
                <i class="material-icons tiny sort-icon" 
                   [ngClass]="{'active': sortColumn === 'strEmail', 'inactive': sortColumn !== 'strEmail'}">
                  {{ sortColumn === 'strEmail' && sortDirection === 'desc' ? 'arrow_drop_down' : 'arrow_drop_up' }}
                </i>
              </th>
              <th (click)="sortTable('strContact')" class="sortable">
                Phone
                <i class="material-icons tiny sort-icon" 
                   [ngClass]="{'active': sortColumn === 'strContact', 'inactive': sortColumn !== 'strContact'}">
                  {{ sortColumn === 'strContact' && sortDirection === 'desc' ? 'arrow_drop_down' : 'arrow_drop_up' }}
                </i>
              </th>
              <th (click)="sortTable('strAccountStatus')" class="sortable">
                Account Status
                <i class="material-icons tiny sort-icon" 
                   [ngClass]="{'active': sortColumn === 'strAccountStatus', 'inactive': sortColumn !== 'strAccountStatus'}">
                  {{ sortColumn === 'strAccountStatus' && sortDirection === 'desc' ? 'arrow_drop_down' : 'arrow_drop_up' }}
                </i>
              </th>
              <th (click)="sortTable('strAccountStatusDate')" class="sortable">
                Status Date
                <i class="material-icons tiny sort-icon" 
                   [ngClass]="{'active': sortColumn === 'strAccountStatusDate', 'inactive': sortColumn !== 'strAccountStatusDate'}">
                  {{ sortColumn === 'strAccountStatusDate' && sortDirection === 'desc' ? 'arrow_drop_down' : 'arrow_drop_up' }}
                </i>
              </th>
              <th (click)="sortTable('dteCreated')" class="sortable">
                Date Created
                <i class="material-icons tiny sort-icon" 
                   [ngClass]="{'active': sortColumn === 'dteCreated', 'inactive': sortColumn !== 'dteCreated'}">
                  {{ sortColumn === 'dteCreated' && sortDirection === 'desc' ? 'arrow_drop_down' : 'arrow_drop_up' }}
                </i>
              </th>
              <th>Actions</th>
            </tr>
          </thead>
          
          <tbody>
            <tr *ngFor="let row of filteredAccounts; trackBy: trackById" 
            [ngClass]="{ 'flagged-row': row.blnFlagged }"
            class="table-row">
              <td>
                <div *ngIf="loadingStates.company" class="spinner-wrapper">
                  <div class="spinner"></div>
                </div>
                {{ row.company?.strCompanyName }}
              </td>
              <td>{{ row.strName }}</td>
              <td>{{ row.strEmail }}</td>
              <td>{{ row.strContact }}</td>
              <td>{{ row.strAccountStatus }}</td>
              <td>{{ row.strAccountStatusDate | date: 'MMM d, y' }}</td>
              <td>{{ row.dteCreated | date: 'MMM d, y'}}</td>
              <td>
                <button (click)="openViewForm(row.intUserPK)" class="btn-view">
                  View Full <i class="material-icons tiny">call_made</i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
        
        <div *ngIf="loadingStates.table" class="spinner-wrapper">
          <div class="spinner"></div>
        </div>

      </div>
    </div>
    
  </div>
</body>
<router-outlet></router-outlet>
